import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { PurchaseOrderForm } from "../../../../../../components/secondaryComponents/PurchaseOrder";
import { BackButton } from "../../../../../../components/primaryComponents";

export const CreatePurchaseOrder = () => {
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Create Purchase Orders"
      description="Create new purchase order"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div className="d-flex align-items-center">
            <BackButton />
            <h4 className="ml-2 mb-0">Create Purchase Order</h4>
          </div>

          <PurchaseOrderForm />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
